import {gdsc,codechefclub,hod,sih,reva,gavs_logo,gavs_photo,hackercup_logo,hackercup_photo,samsung_research_logo,amazon_alexa_logo } from "../assets/images";
import {
    css,
    express,
    git,
    github,
    html,
    javascript,
    linkedin,
    nextjs,
    nodejs,
    react,
    tailwindcss,
    typescript,
    rxjs,
    postcss,
    threejs,
    python,
    cpp,
    firebase,
    pandas,
    solidity,
    django,
    numpy,
    opencv,
    sql,
    firerescue1,
    firerescue2,
    lms,
    chess,
    sudoku,
    portfolio,
    codeforces,
    codewars,
    codechef,
    leetcode,
    whatsapp,
    gmail,
    sihlogo,
    revalogo,
    credly
} from "../assets/icons";

export const skills = [
    {
        imageUrl: css,
        name: "CSS",
        type: "Frontend",
    },
    {
        imageUrl: express,
        name: "Express",
        type: "Backend",
    },
    {
        imageUrl: git,
        name: "Git",
        type: "Version Control",
    },
    {
        imageUrl: github,
        name: "GitHub",
        type: "Version Control",
    },
    {
        imageUrl: html,
        name: "HTML",
        type: "Frontend",
    },
    {
        imageUrl: javascript,
        name: "JavaScript",
        type: "Frontend",
    },
    {
        imageUrl: nextjs,
        name: "Next.js",
        type: "Frontend",
    },
    {
        imageUrl: nodejs,
        name: "Node.js",
        type: "Backend",
    },
    {
        imageUrl: react,
        name: "React",
        type: "Frontend",
    },
    {
        imageUrl: tailwindcss,
        name: "Tailwind CSS",
        type: "Frontend",
    },
    {
        imageUrl: typescript,
        name: "TypeScript",
        type: "Frontend",
    },
    {
        imageUrl: rxjs,
        name: "RXJs",
        type: "Frontend",
    }
    ,
    {
        imageUrl: postcss,
        name: "PostCSS",
        type: "Frontend",
    }
    ,
    {
        imageUrl: threejs,
        name: "ThreeJS",
        type: "Frontend",
    }
    ,
    {
        imageUrl: python,
        name: "Python",
        type: "Backend",
    }
    ,
    {
        imageUrl: cpp,
        name: "C++",
        type: "Backend",
    }
    ,
    {
        imageUrl: firebase,
        name: "Firebase",
        type: "Database",
    }
    ,
    {
        imageUrl: pandas,
        name: "Pandas",
        type: "ML",
    }
    ,
    {
        imageUrl: solidity,
        name: "Solidity",
        type: "Blockchain",
    }
    ,
    {
        imageUrl: django,
        name: "Django",
        type: "Backend",
    }
    ,
    {
        imageUrl: numpy,
        name: "Numpy",
        type: "ML",
    }
    ,
    {
        imageUrl: opencv,
        name: "OpenCV",
        type: "ML",
    }
    ,
    {
        imageUrl: sql,
        name: "SQL",
        type: "Database",
    }

];

export const experiences = [
    {
        title: "Software Development Engineer Intern",
        company_name: "Amazon, Alexa Communications",
        icon: amazon_alexa_logo,
        iconBg: "#b7e4c7",
        date: "July 2025 - December 2025",
        points: [
        ],
    },
    {
        title: "AI Research Intern",
        company_name: "Samsung R&D Institute India - Bangalore",
        icon: samsung_research_logo,
        iconBg: "#fbc3bc",
        date: "July 2024 - June 2025",
        points: [
            "Developed an AI Data storage marketplace to store SHA-256 Hashes of AI models/datasets on the Ethereum blockchain using Solidity-based smart contract.",
            "Made a Kotlin-based Android application to verify the authenticity of on-device AI models by comparing their local hash with the reference stored on the blockchain.",
        ],
    },
    {
        title: "Competitive Programming Lead",
        company_name: "CodeChef VIT-Chennai Chapter",
        icon: codechefclub,
        iconBg: "#e6e62d",
        date: "April 2024 - April 2025",
        points: [
            "Part of team that developed the official website for the club using React and Sanity.",
            "Conducted several hands-on Competitive Programming sessions to beginners.",
        ],
    },
];

export const socialLinks = [
    {
        name: 'GitHub',
        iconUrl: github,
        link: 'https://github.com/sairamnst',
    },
    {
        name: 'LinkedIn',
        iconUrl: linkedin,
        link: 'https://www.linkedin.com/in/sairam-m-327015256/',
    },
    {
        name: 'Credly',
        iconUrl: credly,
        link: 'https://www.credly.com/users/sairamm/badges#other',
    },
    {
        name: 'Codeforces',
        iconUrl: codeforces,
        link: 'https://codeforces.com/profile/sairamnst',
    },
    {
        name: 'Codechef',
        iconUrl: codechef,
        link: 'https://www.codechef.com/users/sairamnst1234',
    },
    {
        name: 'Leetcode',
        iconUrl: leetcode,
        link: 'https://leetcode.com/sairamnst1234/',
    },
    {
        name: 'Codewars',
        iconUrl: codewars,
        link: 'https://www.codewars.com/users/sairamnst',
    },
    {
        name: 'Whatsapp',
        iconUrl: whatsapp,
        link: 'https://api.whatsapp.com/send?phone=919489837945',
    },
    {
        name: 'Email',
        iconUrl: gmail,
        link: 'mailto:sairamnst1234@gmail.com',
    },
];

export const projects = [
    {
        iconUrl: firerescue2,
        theme: 'btn-back-red',
        name: 'Live Video Dehazing for Fire Rescue Operations',
        description: 'Smart India Hackathon 2023 Project. Implemented a light-weighted software that could be integrated with body-camera and could be run on various devices with low computing power. The software does live dehazing of hazy videos that are caused due to smoke emission during a fire accident. Improved the original algorithm that ran at 1 frame per 4-8 seconds to 30-40 frames per second thereby giving a total of 80% increase in performance compared to the project that was submitted for the internal hackathon. The device also uses a people-detection model developed using a custom made dataset. Also the software is designed to detect people that are not covered in the field-of- vision of the rescuer and give an alert calling out their their location.',
        link: 'https://drive.google.com/file/d/1eCYnvHReuRdkymBJpMJQVNkQZkzI6PMI/view?usp=embed_facebook',
    },
    {
        iconUrl: portfolio,
        theme: 'btn-back-orange',
        name: '3D Portfolio Website Made Using ThreeJS',
        description: 'Made a 3D portfolio website using ReactJS and ThreeJS. Integrated various 3d models and animations inside the website.',
        link: '/',
    },
    {
        iconUrl: chess,
        theme: 'btn-back-green',
        name: 'Decentralised Web 3.0 Chess App',
        description: 'Web 3.0 Chess App built using React Js and Solidity. There are 3 modes: Local where 2 players can play on a single system, Online where people using 2 different systems at any location can play by sharing game link and Computer Mode where you go up against an AI. The Online mode is made using Firebase and and RXJS to connect to end-users. The Computer mode\'s AI is built using Algorithms like Min-Max theory, alpha -beta pruning and chess logics. There is a page where you can transfer Ethereum across any wallet, written using Ethereum Smart Contract. Smart Contract to implement betting logic is yet to be implemented...',
        link: 'https://github.com/sairamnst/chess-app',
    },
    {
        iconUrl: firerescue1,
        theme: 'btn-back-blue',
        name: 'Single Image Smoke Dehazing for Fire Alert System hosted using Django backend',
        description: 'SIH 2023 Internal Hackathon project. Implemented a Single Image Dehazing algorithm to dehaze smoke in images for better Fire Detection. Fire detection Machine Learning algorithm is implemented using YOLO detection model to detect fire in images, trained using datasets of fire-related images. Upon detection of fire, text-message is sent to user\'s mobile device. The whole project is hosted on a website with Django as its backend and native-html and css as Frontend.',
        link: '',
    },
    {
        iconUrl: lms,
        theme: 'btn-back-pink',
        name: 'Decentralised Education Platform',
        description: 'Reva Hack 2023 project. Decentralized Education Platform built using React Js for the frontend and DJANGO for the backend. Uses content-based filtering to recommend courses to users(collaborative filtering yet to be implemented). User could connect their MetaMask account and buy the courses using decentralized currency.',
        link: 'https://github.com/sairamnst/reva-hack',
    },
    {
        iconUrl: sudoku,
        theme: 'btn-back-yellow',
        name: 'Sudoku Solver',
        description: 'Sudoku Solver web application which on entering a Sudoku question, solves it and gives the correct solution. It is built using basic HTML and CSS and a javascript file that uses recursion and backtracking to find a possible solution to the problem.',
        link: 'https://github.com/sairamnst/sudokusolver',
    }
];

export const achievements = [
    {
        title: "All India Rank 61 in Meta Hacker Cup 2024 Practice Round.",
        issued_by: "Issued by Meta Platforms(Facebook)",
        image: hackercup_photo,
        icon: hackercup_logo,
        iconBg: "#ffffff",
        date: "September 2024",
    },
    {
        title: "Smart India Hackathon 2023 Winner",
        issued_by: "Issued by AICTE and The Ministry of Defence",
        image: sih,
        icon:sihlogo,
        iconBg: "#accbe1",
        date: "December 2023",
    },
    {
        title: "Gen AI Hackathon Winner",
        issued_by: "Issued by Gavs Technologies | GS Labs",
        image: gavs_photo,
        icon:gavs_logo,
        iconBg: "#f5f540",
        date: "April 2024",
    },
    {
        title: "RevaHack 2023 Finalist",
        issued_by: "Reva University, Bangalore",
        image: reva,
        icon:revalogo,
        iconBg: "#adff2f",
        date: "November 2023",
    },
    {
        title: "GDSC House of Developers Hackathon Finalist",
        issued_by: "Issued by Zeeve and Google Developer Student Club, VIT Chennai",
        image: hod,
        icon:gdsc,
        iconBg: "#fbc3bc",
        date: "November 2022",
    },
];